import { ProjectService } from 'src/app/_services/project/project.service';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { TimesheetService } from 'src/app/_services/timesheet/timesheet.service';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { convertYYYYMMDDtoDDMMYYYY } from 'src/app/_helpers/utils';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProjectTaskService } from 'src/app/_services/project_task/project-task.service';
import { ProjectResourcesService } from 'src/app/_services/projectResources/project-resources.service';
import { TaskService } from 'src/app/_services/task/task.service';

@Component({
  selector: 'app-timesheetV2',
  templateUrl: './timesheetV2.component.html',
  styleUrls: ['./timesheetV2.component.scss'],
})
export class TimeSheetV2Component implements OnInit {
  
  form: FormGroup;
  timesheetForm;
  timesheetReportForm;
  tenantId: string;
  userDetails: any;
  currentUser: any;
  jsonData: any;
  selectedCheckboxData = [];
  userDropdownList = [];
  projectDropdownList = [];
  projectTaskDropdown: any = [];
  subProjectDropdownList: any = [];
  getProjectDetailsList: any;
  getUserName: any;
  projectDetailList: any;
  selectedProjectId: any;
  isAdministrator: boolean = false;
  isPMOLeadManager: boolean = false;
  isPMOAdmin: boolean = false;
  rowData: any;  // row data and column definitions
  rowSelection: any;
  public columnDefs: ColDef[];
  modeAction: number = 1; //1 - create // 2 - update
  sampleGridFrameworkComponents: any;
  lafduration: number;
  private api: GridApi; // gridApi and columnApi
  private columnApi: ColumnApi;
  defaultColDef: any;
  deleteConfirmationMsg = 'Are you sure you want to delete';
  currentDate: any;
  today= new Date();
  isDisableEdit: boolean = false;
  minStartDate: any;
  minEndDate: any;
  
  constructor(
    private storageService: LocalStorageService,
    private timesheetService: TimesheetService,
    private formBuilder: FormBuilder,
    private allocationService: AllocationService,
    private projectService: ProjectService,
    private datePipe: DatePipe,
    private router: Router,
    private snackBar: MatSnackBar,
    private taskService: TaskService,
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent,
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required],
    });

    this.timesheetReportForm = this.formBuilder.group({
      startDate: new FormControl(''),
      endDate: new FormControl(''),
    });

    this.timesheetForm = this.formBuilder.group({
      id: new FormControl(''),
      assignedTo: new FormControl('', Validators.required),
      assignedToUserName: new FormControl(''),
      projectV2Id: new FormControl('', Validators.required),
      projectV2Name: new FormControl(''),
      subprojectV2Id: new FormControl(''),
      subProjectV2Name: new FormControl(''),
      projectV2TaskId: new FormControl(''),
      projectV2TaskName: new FormControl(''),
      description: new FormControl(''),
      startDate: new FormControl('', Validators.required),
      endDate: new FormControl(''),
      totalHours: new FormControl(''),
      approvedHours: new FormControl(''),
      status: new FormControl(''),
      efficiency: new FormControl(''),
      projectV2ManagerName: new FormControl(''),
      projectV2LeadName: new FormControl(''),
      partList: new FormControl(''),
      commodity: new FormControl(''),
      businessGroup: new FormControl(''),
      taskStartDate: new FormControl(''),
      taskEndDate: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.tenantId = this.storageService.get('tenantId');
    this.isAdministrator = this.currentUser.roles.includes('RoleAdministrator');
    this.isPMOAdmin = this.currentUser.roles.includes('RolePmoAdministrator');
    this.isPMOLeadManager = this.currentUser.roles.includes('RolePmoManager') || this.currentUser.roles.includes('RoleReportsExtractor');
    this.getTimesheet();
    this.getUserList();
    this.getProjectDetails();
  }

  // getter for easy access to form fields
  get f() {
    return this.timesheetForm.controls;
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  gettsfromduration(e) {
    this.lafduration = e.target.value;
  }

  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      this.getUserName = response;
      for (let item of response) {
        this.userDropdownList.push(
          `${item.id} . ${item.firstName} ${item.lastName}`
        );
      }
    });
  }

  getProjectDetails(){
    this.projectDropdownList = [];
    if(this.isAdministrator || this.isPMOAdmin){
      this.projectService.getAllRootProjectV2().subscribe((response: any) => {
        this.getProjectDetailsList = response;
        for (let item of response) {
          this.projectDropdownList.push(`${item.id} . ${item.projectName}`);
        }
      });
    } else{
      this.projectService.getAllProjectV2ByUserId(this.currentUser.id).subscribe((response: any) => {
        this.getProjectDetailsList = response;
        for (let item of response) {
          this.projectDropdownList.push(`${item.id} . ${item.projectName}`);
        }
      });
    }
  }

  getTimesheet() {
    this.timesheetService.getAllTimesheetV2(this.currentUser.id).subscribe((response: any) => {
      this.rowData = response;
    });
  }

  timesheetReport(){
    this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/timesheets/timesheetV2-report']);
  }

  projectTask(){
    this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/timesheets/project-taskV2']);
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  // create column definitions
  private createColumnDefs() {
    return [
      {
        headerName: 'Date',
        field: 'startDate',
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: 'Assigned User',
        field: 'assignedToUserName',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Project Name',
        field: 'projectV2Name',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Sub-Project Name',
        field: 'subProjectV2Name',
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: 'Project Task',
        field: 'projectV2TaskName',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Total Hours',
        field: 'totalHours',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Approved Hours',
        field: 'approvedHours',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Efficiency',
        field: 'efficiency',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Description',
        field: 'description',
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: 'Business Group',
        field: 'businessGroup',
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: 'Commodity',
        field: 'commodity',
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: 'Part List',
        field: 'partList',
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: 'Status',
        field: 'status',
        maxWidth: 150,
        cellStyle: (params) => {
          if (params.value === 'Save' || params.value === 'save') {
            return { color: 'blue', 'font-weight': 'bold' };
          } else if (params.value === 'Submit' || params.value === 'submit') {
            return { color: 'orange', 'font-weight': 'bold' };
          } else if (params.value === 'Approved' || params.value === 'approved') {
            return { color: 'green', 'font-weight': 'bold' };
          } else if (params.value === 'Reject' || params.value === 'reject') {
            return { color: 'red', 'font-weight': 'bold' };
          } else if (params.value === 'Withdraw' || params.value === 'withdraw') {
            return { color: 'grey', 'font-weight': 'bold' };
          }
          return null;
        },
        filter: true,
        editable: false,
        sortable: true,
      },
    ];
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = [];
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data);
    }
    this.currentDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    if(this.currentDate > this.selectedCheckboxData[0].startDate){
      if(this.selectedCheckboxData[0].status === 'Submit'){
        this.isDisableEdit = true;
      }
    }
  }
  
  onChangeEvent(event){
    this.timesheetForm.value.endDate = this.timesheetForm.get('startDate').value;
    this.timesheetForm.patchValue(this.timesheetForm.value);
  }

  createOpenModal() {
    this.modeAction = 1;
    this.timesheetForm.reset();
    this.timesheetForm.patchValue({
      id: '',
      assignedTo: this.currentUser.id + ' . ' + this.currentUser.firstName + ' ' + this.currentUser.lastName,
      projectV2Id: '',
      subprojectV2Id: '',
      projectManagerName: '',
      projectLeadName: '',
      projectV2TaskId: '',
      partList: '',
      commodity: '',
      businessGroup: '',
      description: '',
      startDate: '',
      endDate: '',
      taskStartDate: '',
      taskEndDate: '',
      totalHours: '',
      approvedHours: '',
      efficiency: '',
      status: '',
    });
  }

  createTimesheet() {
    let details = {
      assignedTo: parseInt(this.timesheetForm.get('assignedTo').value.toString().split(" . ")[0]),
      projectV2Id: parseInt(this.timesheetForm.get('projectV2Id').value.toString().split(" . ")[0]),
      subprojectV2Id: parseInt(this.timesheetForm.get('subprojectV2Id').value?.toString().split(" . ")[0]),
      projectV2TaskId: parseInt(this.timesheetForm.get('projectV2TaskId').value.toString().split(" . ")[0]),
      description: this.timesheetForm.get('description').value,
      startDate: this.timesheetForm.get('startDate').value,
      endDate: this.timesheetForm.get('endDate').value,
      totalHours: this.timesheetForm.get('totalHours').value,
      status: this.timesheetForm.get('status').value,
    };
    if(this.timesheetForm.get('totalHours').value <= 16){
      this.timesheetService.createTimesheetV2(details).subscribe((response: any) => {
        this.api.applyTransaction({ add: [response] });
        $('#closeModalTimeSheet').trigger('click');
      });
    }
    else{
      window.alert("Please check the total hours added, it should be less than 16Hrs");
    }
  }

  editOpenModal() {
    if(this.isDisableEdit){
      this.openSnackBar('You cannot edit old Timesheet Report please contact Your Manager');
      this.isDisableEdit = false;
      this.selectedCheckboxData = [];
    }
    else{
      this.modeAction = 2;
      this.timesheetService.getTimesheetV2(this.selectedCheckboxData[0].id).subscribe((response: any) => {
        let editdetails = {
          assignedTo: response.assignedTo + " . " + response.assignedToUserName,  
          projectV2Id: response.projectV2Id + " . " + response.projectV2Name,
          projectV2TaskId: response.projectV2TaskId + " . " + response.projectV2TaskName,
          description: response.description,
          startDate: response.startDate,
          endDate: response.endDate,
          totalHours: response.totalHours,
          status: response.status,
          projectV2ManagerName: response.projectV2ManagerName,
          projectV2LeadName: response.projectV2LeadName,
          partList: response.partList,
          commodity: response.commodity,
          businessGroup: response.businessGroup,
        };
        if(response.subprojectV2Id){
          this.timesheetForm.value.subprojectV2Id= response.subprojectV2Id + " . " + response.subProjectV2Name;
        }else{
          this.timesheetForm.value.subprojectV2Id= '';
        }
        this.timesheetForm.patchValue(editdetails);
      });
      this.timesheetForm.patchValue(this.selectedCheckboxData[0]);
      this.getTaskDetails(this.selectedCheckboxData[0].projectV2TaskId);
    }
  }

  updateTimesheeets() {
    let updatedetails = {
      assignedTo: parseInt(this.timesheetForm.get('assignedTo').value.toString().split(" . ")[0]),
      projectV2Id: parseInt(this.timesheetForm.get('projectV2Id').value.toString().split(" . ")[0]),
      subprojectV2Id: parseInt(this.timesheetForm.get('subprojectV2Id').value?.toString().split(" . ")[0]),
      projectV2TaskId: parseInt(this.timesheetForm.get('projectV2TaskId').value.toString().split(" . ")[0]),
      description: this.timesheetForm.get('description').value,
      startDate: this.timesheetForm.get('startDate').value,
      endDate: this.timesheetForm.get('endDate').value,
      totalHours: this.timesheetForm.get('totalHours').value,
      status: this.timesheetForm.get('status').value,
    };
    if(this.timesheetForm.get('totalHours').value <= 16){
      this.timesheetService.updateTimesheetV2(updatedetails, parseInt(this.selectedCheckboxData[0].id)).subscribe((res) => {
        this.getTimesheet();
        this.selectedCheckboxData = [];
        $('#closeModalTimeSheet').trigger('click');
      });
    }
    else{
      window.alert("Please check the total hours added, it should be less than 16Hrs");
    }
  }

  deleteOpenModal() {
    if(this.isDisableEdit){
      this.openSnackBar('You cannot delete old Timesheet Report please contact Your Manager');
      this.isDisableEdit = false;
      this.selectedCheckboxData = [];
    }
    else{
      this.deleteConfirmationMsg = 'Are you sure you want to delete';
      for (let i in this.selectedCheckboxData) {
        if (+i === 0)
          this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].projectName}`;
        else if (this.selectedCheckboxData.length === +i + 1)
          this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].projectName}`;
        else
          this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].projectName}`;
      }
    }
  }

  deleteTimesheetList() {
    this.timesheetService.deleteTimesheetV2(this.selectedCheckboxData[0].id).subscribe(() => {
      this.getTimesheet();
      this.selectedCheckboxData = [];
      $('#closeModalDeleteTimesheet').trigger('click');
    });
  }

  getProjectDetailsByUserId(userId){
    this.projectDropdownList = [];

    this.projectService.getAllProjectV2ByUserId(userId).subscribe((response: any) => {
      this.getProjectDetailsList = response;
      for (let item of response) {
        this.projectDropdownList.push(`${item.id} . ${item.projectName}`);
      }
    });
  }

  getProjectDetailsByUser(user){
    let userId : any;
    if(user.target.value){
      userId = user.target.value.split(' . ')[0];
    }
    else{
      userId = this.currentUser.id;
    }
    this.getProjectDetailsByUserId(userId);
  }

  getSubProjectList(projectId){
    this.subProjectDropdownList = [];
    
    if(this.isAdministrator || this.isPMOAdmin){
      this.projectService.getSubProjectsV2(projectId).subscribe((response: any) => {
        for (let item of response) {
          this.subProjectDropdownList.push(`${item.id} . ${item.projectName}`);
        }
      });
    } else{
      this.projectService.getSubProjectV2ByUserId(this.currentUser.id, projectId).subscribe((response: any) => {
        for (let item of response) {
          this.subProjectDropdownList.push(`${item.id} . ${item.projectName}`);
        }
      });
    }
  }

  gettimesheetSummary(){
    let startDate = this.timesheetReportForm.get('startDate').value;
    startDate = convertYYYYMMDDtoDDMMYYYY(startDate);
    let endDate = this.timesheetReportForm.get('endDate').value;
    endDate = convertYYYYMMDDtoDDMMYYYY(endDate);
    this.timesheetService.getTimesheetV2DateRange(startDate, endDate).subscribe((response: any) => {
      if(response && response.length > 0) {
        this.rowData = response;
      } else {
        this.rowData = [];
      }
    });
  }

  fetchProjectDetails(projectId){
    this.timesheetForm.patchValue({
      subprojectV2Id : '',
      projectV2ManagerName: '',
      projectV2LeadName: '',
      projectV2TaskId: '',
      businessGroup: '',
      commodity: '',
      partList: '',
      startDate: '',
      endDate: '',
      totalHours: '',
      status: '',
      description: ''
    })
    let selectedProject = projectId.target.value;
    this.selectedProjectId = selectedProject.split(' . ')[0];
    this.getSubProjectList(this.selectedProjectId);
    this.getProjectTaskByProjectId();
    //Get ProjectManager Details
    this.projectService.getProjectV2(this.selectedProjectId).subscribe((response: any) => {
      if (response) {
       this.timesheetForm.value.projectV2ManagerName = response.projectManagerName;
       this.timesheetForm.value.projectV2LeadName = response.projectLeadName;
       this.timesheetForm.value.businessGroup = response.businessGroupName;
       this.timesheetForm.value.commodity = response.commodityName;
       this.timesheetForm.patchValue(this.timesheetForm.value);
      }
    });
  }

  getProjectTaskByProjectId(){
    this.projectTaskDropdown = [];
    if(this.timesheetForm.get('assignedTo').value){
      let id = this.timesheetForm.get('assignedTo').value.split(' . ')[0];
      this.taskService.getProjectTaskV2ByStatus(id, this.selectedProjectId).subscribe((response: any) => {
        if(response){
          for (let item of response) {
            this.projectTaskDropdown.push(`${item.id} . ${item.projectV2TaskName}`);
          }
        }
      });
    }
    else{
      this.taskService.getProjectTaskV2ByStatus(this.currentUser.id, this.selectedProjectId).subscribe((response: any) => {
        if(response){
          for (let item of response) {
            this.projectTaskDropdown.push(`${item.id} . ${item.projectV2TaskName}`);
          }
        }
      });
    }
  }

  getSubProjectTaskByProjectId(subprojectId){
    this.projectTaskDropdown = [];
    let selectedSubProjectId = subprojectId.target.value.split(' . ')[0];
    if(this.timesheetForm.get('assignedTo').value){
      let id = this.timesheetForm.get('assignedTo').value.split(' . ')[0];
      if(selectedSubProjectId){
        this.taskService.getProjectTaskV2ByStatus(id, selectedSubProjectId).subscribe((response: any) => {
          if(response){
            for (let item of response) {
              this.projectTaskDropdown.push(`${item.id} . ${item.projectV2TaskName}`);
            }
          }
        });
      }
      else{
        this.taskService.getProjectTaskV2ByStatus(id, this.selectedProjectId).subscribe((response: any) => {
          if(response){
            for (let item of response) {
              this.projectTaskDropdown.push(`${item.id} . ${item.projectV2TaskName}`);
            }
          }
        });
      } 
    }
    else{
      if(selectedSubProjectId){
        this.taskService.getProjectTaskV2ByStatus(this.currentUser.id, selectedSubProjectId).subscribe((response: any) => {
          if(response){
            for (let item of response) {
              this.projectTaskDropdown.push(`${item.id} . ${item.projectV2TaskName}`);
            }
          }
        });
      }
      else{
        this.taskService.getProjectTaskV2ByStatus(this.currentUser.id, this.selectedProjectId).subscribe((response: any) => {
          if(response){
            for (let item of response) {
              this.projectTaskDropdown.push(`${item.id} . ${item.projectV2TaskName}`);
            }
          }
        });
      }
    }
  }

  getTaskDetails(task){
    let taskId: any;
    if(this.modeAction === 2){
      taskId = task;
    }
    else{
      taskId = parseInt(this.timesheetForm.get('projectV2TaskId').value.toString().split(" . ")[0]);
    }

    this.taskService.getProjectTasksV2ById(taskId).subscribe((response: any) => {
      this.timesheetForm.value.partList = response.partList;
      this.timesheetForm.value.taskStartDate = response.startDate;
      this.timesheetForm.value.taskEndDate = response.endDate;
      this.timesheetForm.value.description = response.description;
      this.timesheetForm.patchValue(this.timesheetForm.value);
      this.timesheetForm.value.totalHours = 8;
      if(response.estimatedHours>=8){
        this.timesheetForm.value.totalHours = 8;
        this.timesheetForm.patchValue(this.timesheetForm.value);
      }
      else{
        this.timesheetForm.value.totalHours = response.estimatedHours;
        this.timesheetForm.patchValue(this.timesheetForm.value);
      }
      
      this.minStartDate = this.datePipe.transform(response.startDate, 'yyyy-MM-dd');
      this.minEndDate = this.datePipe.transform(response.endDate, 'yyyy-MM-dd');
    });
  }
  
}